import type {
  ComponentName,
  TokenInteraction,
  TokenStrokeType,
  TokenType,
  TokenUsage,
} from './types';

type ContextualizedTokenOptions = {
  componentName: ComponentName;
  type: TokenType;
  usage: TokenUsage;
  interaction?: TokenInteraction;
  strokeType?: TokenStrokeType;
};

const tokenPrefix = '--reserved-atlas-ui';

export const createContextualizedToken = ({
  componentName,
  type,
  usage,
  interaction,
  strokeType,
}: ContextualizedTokenOptions): [
  (token: string) => Record<string, string>,
  (token: string) => string,
] => {
  const tokenName = `${tokenPrefix}-${componentName}-${type}-${usage}${
    interaction ? `-${interaction}` : ''
  }${strokeType ? `-${strokeType}` : ''}`;

  const setter = (token: string) => {
    return {
      [tokenName]: `var(${token})`,
    };
  };

  const proxy = (token: string) => {
    return `var(${tokenName}, var(${token}))`;
  };

  return [setter, proxy];
};
